class TreatmentController {
  /* @ngInject */
  constructor($stateParams, $http, Endpoints) {
    Object.assign(this, {
      $params: $stateParams,
      $http,
      Endpoints
    });
    this.treatmentName = $stateParams.id;
    this.getTreatment();
  }

  getTreatment() {
    this.loading = true;
    this.$http.get(this.Endpoints.plans.treatment.replace(':treatment', this.$params.id), {
      loadingText: 'Loading Treatment Plan'
    }).then(({
      data
    }) => this.treatment = data).catch(() => this.error = true).finally(() => this.loading = false);
  }

}

TreatmentController.$inject = ["$stateParams", "$http", "Endpoints"];
angular.module('pims').controller('TreatmentController', TreatmentController);